import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { Input, Tag } from "../ui";

const PAPEL_LABEL = { proprietario: "Proprietário", associado: "Associado", estagiario: "Estagiário" };

/** Lista de perfis (todos os usuários/logins de todos os escritórios). */
const AdminPerfis = () => {
    const [usuarios, setUsuarios] = useState([]);
    const [busca, setBusca] = useState("");

    useEffect(() => {
        api.get("/admin/usuarios").then((r) => setUsuarios(r.data)).catch(() => {});
    }, []);

    const q = busca.toLowerCase();
    const filtrados = usuarios.filter((u) =>
        (u.nome || "").toLowerCase().includes(q) ||
        (u.email || "").toLowerCase().includes(q) ||
        (u.nome_escritorio || "").toLowerCase().includes(q)
    );

    return (
        <div>
            <div className="toolbar">
                <h3 style={{ margin: 0 }}>Perfis ({usuarios.length})</h3>
                <div className="toolbar-spacer">
                    <Input placeholder="Buscar por nome, e-mail ou escritório" value={busca} onChange={(e) => setBusca(e.target.value)} />
                </div>
            </div>
            <div className="scroll-x">
                <table className="table">
                    <thead><tr><th>Nome</th><th>E-mail</th><th>Escritório</th><th>Papel</th><th>OAB</th><th>Situação</th></tr></thead>
                    <tbody>
                        {filtrados.map((u) => (
                            <tr key={u.id_usuario}>
                                <td>{u.nome}</td>
                                <td>{u.email}</td>
                                <td>{u.nome_escritorio}</td>
                                <td><Tag tom={u.papel === "proprietario" ? "accent" : "neutral"}>{PAPEL_LABEL[u.papel]}</Tag></td>
                                <td className="num">{u.OAB ? `${u.OAB}${u.UF_OAB ? "/" + u.UF_OAB : ""}` : "—"}</td>
                                <td><Tag tom={u.ativo ? "success" : "danger"}>{u.ativo ? "ativo" : "desativado"}</Tag></td>
                            </tr>
                        ))}
                        {filtrados.length === 0 && <tr><td colSpan="6" className="text-muted">Nenhum perfil encontrado.</td></tr>}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminPerfis;
